export enum ConsumptionTab {
  TOTALS = 'totals',
  COST = 'cost',
}
